import moment from 'moment';

const JOURNEY_FILL_NAMES = {
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  EMAIL: 'Email',
  BIRTHDAY: 'Birthday',
  GENDER: 'Gender',
  MARITAL_STATUS: 'Marital status',
  NATIONALITY: 'Nationality',
  PHONE: 'Phone',
  BILLING_ADDRESS: 'Billing Address',
  SHIPPING_ADDRESS: 'Shipping Address',
  COMPANY_NAME: 'Company Name',
  VAT_NUMBER: 'VAT Number',
  SIREN: 'SIREN',
  SOCIAl_SECURITY_NUMBER: 'Social Security Number',
  IBAN: 'IBAN',
  SWIFT: 'SWIFT/BIC',
  CARD_NUMBER: 'Card/Passport Number',
  USER_NUMBER: 'User Number',
};

// Function to determine the appropriate case for a field name
const getFieldNameCase = fieldName => {
  if (fieldName.startsWith(JOURNEY_FILL_NAMES.FIRST_NAME)) {
    return JOURNEY_FILL_NAMES.FIRST_NAME;
  }
  if (fieldName.startsWith(JOURNEY_FILL_NAMES.EMAIL)) {
    return JOURNEY_FILL_NAMES.EMAIL;
  }
  if (fieldName.startsWith(JOURNEY_FILL_NAMES.LAST_NAME)) {
    return JOURNEY_FILL_NAMES.LAST_NAME;
  }
  if (fieldName.startsWith(JOURNEY_FILL_NAMES.BIRTHDAY)) {
    return JOURNEY_FILL_NAMES.BIRTHDAY;
  }
  if (fieldName.startsWith(JOURNEY_FILL_NAMES.GENDER)) {
    return JOURNEY_FILL_NAMES.GENDER;
  }
  if (fieldName.startsWith(JOURNEY_FILL_NAMES.MARITAL_STATUS)) {
    return JOURNEY_FILL_NAMES.MARITAL_STATUS;
  }
  if (fieldName.startsWith(JOURNEY_FILL_NAMES.NATIONALITY)) {
    return JOURNEY_FILL_NAMES.NATIONALITY;
  }
  if (fieldName.startsWith(JOURNEY_FILL_NAMES.PHONE)) {
    return JOURNEY_FILL_NAMES.PHONE;
  }
  if (fieldName.startsWith(JOURNEY_FILL_NAMES.BILLING_ADDRESS)) {
    return JOURNEY_FILL_NAMES.BILLING_ADDRESS;
  }
  if (fieldName.startsWith(JOURNEY_FILL_NAMES.SHIPPING_ADDRESS)) {
    return JOURNEY_FILL_NAMES.SHIPPING_ADDRESS;
  }
  if (fieldName.startsWith(JOURNEY_FILL_NAMES.COMPANY_NAME)) {
    return JOURNEY_FILL_NAMES.COMPANY_NAME;
  }
  if (fieldName.startsWith(JOURNEY_FILL_NAMES.VAT_NUMBER)) {
    return JOURNEY_FILL_NAMES.VAT_NUMBER;
  }
  if (fieldName.startsWith(JOURNEY_FILL_NAMES.SIREN)) {
    return JOURNEY_FILL_NAMES.SIREN;
  }
  if (fieldName.startsWith(JOURNEY_FILL_NAMES.SOCIAl_SECURITY_NUMBER)) {
    return JOURNEY_FILL_NAMES.SOCIAl_SECURITY_NUMBER;
  }
  if (fieldName.startsWith(JOURNEY_FILL_NAMES.IBAN)) {
    return JOURNEY_FILL_NAMES.IBAN;
  }
  if (fieldName.startsWith(JOURNEY_FILL_NAMES.SWIFT)) {
    return JOURNEY_FILL_NAMES.SWIFT;
  }
  if (fieldName.startsWith(JOURNEY_FILL_NAMES.CARD_NUMBER)) {
    return JOURNEY_FILL_NAMES.CARD_NUMBER;
  }
  if (fieldName.startsWith(JOURNEY_FILL_NAMES.USER_NUMBER)) {
    return JOURNEY_FILL_NAMES.USER_NUMBER;
  }
  return null; // Default case if no match is found
};

const fillFormFields = (formFields, user) => ({
  ...formFields,
  formFieldValues: formFields?.formFieldValues?.map(field => {
    const newField = { ...field }; // Create a new object to avoid mutating original
    let dateFormat = null;

    // Retrieves the format on the annotation
    if (getFieldNameCase(field.name) === JOURNEY_FILL_NAMES.BIRTHDAY) {
      const annotationForBirthday = formFields?.annotations?.find(
        annotation => annotation.formFieldName === newField.name,
      );
      if (annotationForBirthday?.additionalActions) {
        dateFormat = annotationForBirthday?.additionalActions?.onFormat?.script
          ?.split('"')?.[1]
          ?.toUpperCase();
      }
    }

    // Use switch case based on the result of getFieldNameCase function
    switch (getFieldNameCase(field.name)) {
      case JOURNEY_FILL_NAMES.FIRST_NAME:
        newField.value = user?.firstName ? `${user?.firstName}` : '';
        break;
      case JOURNEY_FILL_NAMES.LAST_NAME:
        newField.value = user?.lastName ? `${user?.lastName}` : '';
        break;
      case JOURNEY_FILL_NAMES.EMAIL:
        newField.value = user?.email ? `${user?.email}` : '';
        break;
      case JOURNEY_FILL_NAMES.BIRTHDAY:
        newField.value = user?.birthday
          ? moment(user?.birthday).format(dateFormat)
          : '';
        break;
      case JOURNEY_FILL_NAMES.GENDER:
        newField.value = user?.genre ? `${user?.genre}` : '';
        break;
      case JOURNEY_FILL_NAMES.MARITAL_STATUS:
        newField.value = user?.maritalStatus ? `${user?.maritalStatus}` : '';
        break;
      case JOURNEY_FILL_NAMES.NATIONALITY:
        newField.value = user?.nationality ? `${user?.nationality?.name}` : '';
        break;
      case JOURNEY_FILL_NAMES.PHONE:
        newField.value = user?.phone ? `${user?.phone}` : '';
        break;
      case JOURNEY_FILL_NAMES.BILLING_ADDRESS:
        newField.value = user?.address?.address
          ? `${user?.address?.address}`
          : '';
        break;
      case JOURNEY_FILL_NAMES.SHIPPING_ADDRESS:
        newField.value =
          user?.shippingAddress.length > 0
            ? `${user?.shippingAddress[0]?.address}`
            : user?.address?.address || '';
        break;
      case JOURNEY_FILL_NAMES.COMPANY_NAME:
        newField.value = user?.personalInfo?.companyName
          ? `${user?.personalInfo?.companyName}`
          : '';
        break;
      case JOURNEY_FILL_NAMES.VAT_NUMBER:
        newField.value = user?.personalInfo?.NIF
          ? `${user?.personalInfo?.NIF}`
          : '';
        break;
      case JOURNEY_FILL_NAMES.SIREN:
        newField.value = user?.personalInfo?.SIREN
          ? `${user?.personalInfo?.SIREN}`
          : '';
        break;
      case JOURNEY_FILL_NAMES.SOCIAl_SECURITY_NUMBER:
        newField.value = user?.personalInfo?.socialSecurityNumber
          ? `${user?.personalInfo?.socialSecurityNumber}`
          : '';
        break;
      case JOURNEY_FILL_NAMES.IBAN:
        newField.value = user?.personalInfo?.IBAN?.IBAN
          ? `${user?.personalInfo?.IBAN?.IBAN}`
          : '';
        break;
      case JOURNEY_FILL_NAMES.SWIFT:
        newField.value = user?.personalInfo?.IBAN?.SWIFT
          ? `${user?.personalInfo?.IBAN?.SWIFT}`
          : '';
        break;
      case JOURNEY_FILL_NAMES.CARD_NUMBER:
        newField.value = user?.personalInfo?.card?.id
          ? `${user?.personalInfo?.card?.id}`
          : '';
        break;
      case JOURNEY_FILL_NAMES.USER_NUMBER:
        newField.value = user?.userNumber ? `${user?.userNumber}` : '';
        break;
      default:
        break;
    }
    return newField;
  }),
});

export { fillFormFields, JOURNEY_FILL_NAMES };
